import { render } from "./DialogNewDatabankNumbers.vue?vue&type=template&id=068f4f4d"
import script from "./DialogNewDatabankNumbers.vue?vue&type=script&lang=js"
export * from "./DialogNewDatabankNumbers.vue?vue&type=script&lang=js"

import "./DialogNewDatabankNumbers.vue?vue&type=style&index=0&id=068f4f4d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__